export default __webpack_public_path__ + "static/media/dolphin-house-logo.c4c92e5f.png";